<div class="p-6 flex flex-col gap-4 w-full max-w-4xl">
	<div class="w-full flex justify-between">
		<div class="flex gap-2 flex-col">
			<h2 class="text-2xl font-bold text-gray-900">User Management</h2>
			<p class="text-gray-600">List of users registered in the authentication service</p>
		</div>
		<button mat-flat-button color="accent" (click)="registerUser()">
			<mat-icon class="icon-size-5 mr-2" svgIcon="heroicons_solid:user-add"></mat-icon> Register user </button>
	</div>
	<!-- Loading state -->
	<div *ngIf="loading || checkingPermissions" class="flex justify-center items-center py-8">
		<div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
		<span class="ml-2 text-gray-600"> {{ checkingPermissions ? 'Checking permissions...' : 'Loading users...' }} </span>
	</div>
	<fuse-alert *ngIf="error" [type]="'error'" [appearance]="'outline'">
		<span fuseAlertTitle>Error</span>
		<span class="text-sm font-medium">{{ error }}</span>
	</fuse-alert>
	<!-- Users list -->
	<div *ngIf="!loading && !checkingPermissions && !error" class="bg-card shadow rounded-lg p-6">
		<div class="flex justify-between items-center mb-4">
			<h3 class="text-lg leading-none font-medium text-gray-900 flex items-center"> Users <span *ngIf="searchTerm.trim(); else totalCount"> ({{ filteredUsersCount }} de {{ totalUsers }}) </span>
				<ng-template #totalCount> ({{ totalUsers }} total) </ng-template>
			</h3>
			<!-- Search input -->
			<mat-form-field class="w-80 fuse-mat-dense">
				<input matInput [(ngModel)]="searchTerm" (input)="applyFilter()" type="search" placeholder="Search users by name or email" />
				<mat-icon matSuffix svgIcon="heroicons_outline:search"></mat-icon>
			</mat-form-field>
		</div>
		<div *ngIf="totalUsers === 0" class="text-center py-8 text-gray-500"> No users found </div>
		<div *ngIf="totalUsers > 0 && filteredUsersCount === 0 && searchTerm.trim()" class="text-center py-8 text-gray-500"> No users found for "{{ searchTerm }}" </div>
		<div *ngIf="filteredUsersCount > 0">
			<div class="flex overflow-clip border border-gray-200 rounded-lg overflow-x-scroll">
				<table mat-table [dataSource]="dataSource" class="w-full ">
					<!-- Name Column -->
					<ng-container matColumnDef="name">
						<th mat-header-cell *matHeaderCellDef class="text-xs font-medium text-gray-500 uppercase tracking-wider"> Name </th>
						<td mat-cell *matCellDef="let user" class="whitespace-nowrap text-sm text-gray-900"> {{ (user.firstName || '') + ' ' + (user.lastName || '') || '-' }} </td>
					</ng-container>
					<!-- Email Column -->
					<ng-container matColumnDef="email">
						<th mat-header-cell *matHeaderCellDef class="text-xs font-medium text-gray-500 uppercase tracking-wider"> Email </th>
						<td mat-cell *matCellDef="let user" class="whitespace-nowrap text-sm text-gray-900"> {{ user.email || '-' }} </td>
					</ng-container>
					<!-- Status Column -->
					<ng-container matColumnDef="enabled">
						<th mat-header-cell *matHeaderCellDef class="text-xs font-medium text-gray-500 uppercase tracking-wider"> Status </th>
						<td mat-cell *matCellDef="let user" class="whitespace-nowrap">
							<span class="px-3 py-1 w-fit rounded-full flex uppercase text-xs font-semibold" [class]="user.enabled ? 'bg-green-200 text-green-800' : 'bg-red-100 text-red-800'"> {{ user.enabled ? 'Active' : 'Inactive' }} </span>
						</td>
					</ng-container>
					<!-- Actions Column -->
					<ng-container matColumnDef="actions">
						<th mat-header-cell *matHeaderCellDef class="text-xs font-medium text-gray-500 uppercase tracking-wider"> Actions </th>
						<td mat-cell *matCellDef="let user" class="gap-4 whitespace-nowrap">
							<a [routerLink]="'/apps/user-management/'+ user.id" class="mr-2">
								<button mat-icon-button matTooltip="Edit user access">
									<mat-icon class="icon-size-4" svgIcon="heroicons_solid:view-grid-add"></mat-icon>
								</button>
							</a>
							<button mat-icon-button [matMenuTriggerFor]="userMenu" matTooltip="Options">
								<mat-icon class="icon-size-4" svgIcon="heroicons_solid:dots-vertical"></mat-icon>
							</button>
							<mat-menu #userMenu="matMenu">
								<button mat-menu-item (click)="editUser(user)">
									<mat-icon class="icon-size-4" svgIcon="heroicons_outline:pencil"></mat-icon>
									<span>Edit basic data</span>
								</button>
								<button mat-menu-item (click)="toggleUserStatus(user)">
									<mat-icon class="icon-size-4" [svgIcon]="user.enabled ? 'heroicons_solid:ban' : 'heroicons_solid:check-circle'"></mat-icon>
									<span>{{ user.enabled ? 'Disable' : 'Enable' }}</span>
								</button>
							</mat-menu>
						</td>
					</ng-container>
					<tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-50 h-10 uppercase text-md">
					</tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumns;" class="hover:bg-gray-50 h-12"></tr>
				</table>
			</div>
			<!-- Paginator -->
			<mat-paginator #paginator [length]="totalUsers" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true" class="border-t border-gray-200">
			</mat-paginator>
		</div>
	</div>
</div>